import React from 'react';
import { Outlet } from 'react-router-dom';
import { isUndefined } from 'ramda-adjunct';
import { useLayout } from './context';
import LayoutBase, { Section } from './BaseLayout';
import {useEffect} from 'react';
import { RootieScreen } from './screens/Screen';

export const PublicLayout = (props: any & { children?: JSX.Element[], menuItems: any }) => {
  const { setCurrentLayoutId } = useLayout();
  useEffect(()=> {
    setCurrentLayoutId('layout.public');
  }, [setCurrentLayoutId]); // {

  const children = isUndefined(props.children) ? <Outlet /> : props.children;

  return (
    <LayoutBase>
      <div className={"ebd-no-margin"}>
        {/* <Section id="content" /> */}
        {children}
      </div>
    </LayoutBase>
  );
};
